import { render, staticRenderFns } from "./HomeTiendaAll.vue?vue&type=template&id=081bd5ed&scoped=true"
import script from "./HomeTiendaAll.vue?vue&type=script&lang=js"
export * from "./HomeTiendaAll.vue?vue&type=script&lang=js"
import style0 from "./HomeTiendaAll.vue?vue&type=style&index=0&id=081bd5ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bd5ed",
  null
  
)

export default component.exports